var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { QuestionAnswerState } from '../../learnware/LearnwareEnums';
export class AnsweringState {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get currentAnswerState() {
        if (this.question.context.app.appInfo.isUserCurrentlyEditing) {
            return QuestionAnswerState.Editing;
        }
        if (this.question.context.app.question === this.question) {
            if (this.question.answer.finishDate) {
                // this.question.context.app.cycleHistory.showAnswer) {
                return QuestionAnswerState.History;
            }
            if (this.shouldContinueImmediately) {
                return QuestionAnswerState.Continue;
            }
            if (this.question.answer && this.question.answer.completeDate) {
                return QuestionAnswerState.Feedback;
            }
            return QuestionAnswerState.Answering;
        }
        return QuestionAnswerState.Preload;
    }
    get isCompletlyAnswered() {
        return [QuestionAnswerState.Feedback, QuestionAnswerState.Continue, QuestionAnswerState.History].includes(this.currentAnswerState);
    }
    get isAnswerFinished() {
        return [QuestionAnswerState.Continue, QuestionAnswerState.History].includes(this.currentAnswerState);
    }
    get isInHistoryState() {
        return this.currentAnswerState === QuestionAnswerState.History;
    }
    get isInFeedbackState() {
        return this.currentAnswerState === QuestionAnswerState.Feedback;
    }
    get isInAnsweringState() {
        return this.currentAnswerState === QuestionAnswerState.Answering;
    }
    get wasAnsweredFullyCorrect() {
        return this.isCompletlyAnswered && this.question.answeringInfo.reachedPoints === this.question.maxPoints;
    }
    get wasAnsweredWrong() {
        return this.isCompletlyAnswered && this.question.answeringInfo.reachedPoints !== this.question.maxPoints;
    }
    get wasAnsweredPartiallyWrong() {
        return this.isCompletlyAnswered && this.question.answeringInfo.reachedPoints > 0 && this.wasAnsweredWrong;
    }
    get wasAnsweredCompletlyWrong() {
        return this.isCompletlyAnswered && this.question.answeringInfo.reachedPoints === 0;
    }
    get shouldContinueImmediately() {
        return (!!this.question.answer &&
            (this.question.answer.wasSkipped ||
                this.question.answer.wasBlocked ||
                this.question.answer.wasContinuedImmedately));
    }
    get shouldSetCompletedTimestamp() {
        return this.question.questionScore.shouldSetCompletedTimestamp;
    }
}
__decorate([
    computed
], AnsweringState.prototype, "currentAnswerState", null);
__decorate([
    computed
], AnsweringState.prototype, "shouldContinueImmediately", null);
__decorate([
    computed
], AnsweringState.prototype, "shouldSetCompletedTimestamp", null);
